var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeoplesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 64,
    viewBox: "0 0 91 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.575 32C38.3736 32 45.5 24.84 45.5 16C45.5 7.16 38.3736 0 29.575 0C20.7764 0 13.65 7.16 13.65 16C13.65 24.84 20.7764 32 29.575 32ZM79.625 24C79.625 30.9456 74.0255 36.5714 67.1125 36.5714C60.1995 36.5714 54.6 30.9456 54.6 24C54.6 17.0542 60.1995 11.4286 67.1125 11.4286C74.0255 11.4286 79.625 17.0542 79.625 24ZM29.575 36.5714C35.7939 36.5714 45.9163 38.5168 52.555 42.389C55.2666 45.1623 56.875 48.1861 56.875 51.2V64H0V51.2C0 41.472 19.7042 36.5714 29.575 36.5714ZM91 64H61.425V51.2C61.425 47.9627 60.2616 44.9831 58.4138 42.3237C61.9194 41.5371 65.3705 41.1429 68.0059 41.1429C76.488 41.1429 91 45.2267 91 53.3333V64Z",
    fill: "#FF5910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeoplesIcon);
export default __webpack_public_path__ + "static/media/peoplesIcon.bf0e243d663c80a2d92213095ef99e7e.svg";
export { ForwardRef as ReactComponent };